import React, { useEffect, useState } from 'react';
import './preview-player-landing.styles.scss';
import { previewGameData, previewGameMessages, previewGameStats, previewPlayerCurrentUsers, previewPlayerUserProfiles, previewUserContent } from '../previewGameData';
import { IsDesktop, IsMobile, IsTablet } from '@/utils/responsiveQueries';
import PlayHeadBar from '@/components/PLAYER/play-game-head-bar/play-head-bar.component';
import PlayerGameContent from '@/components/PLAYER/player-game-content.component';
import PlayHeadBarMobile from '@/components/PLAYER/play-game-head-bar/play-head-mobile.component';
import { setCurrentUser, setMembership, setUserProfile } from '@/state/slices/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '@/components/loader/loader.comp';
import { useNavigate } from 'react-router-dom';
import { completePlayerData, leaderList, previewTeamMembers } from '../previewPlayers';
import { gameElementsShortList } from '../previewGameElements';
import { previewCompleteActionItems, previewPendingActionItems } from '../previewGameActionItems';
import PreviewBorder from '../preview-border/preview-border.component';

const PreviewPlayerLanding = () => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const [playerData, setPlayerData] = useState(null);
  const [gameData] = useState(
    previewGameData
      ? previewGameData
      : null
  );
  const [playerList] = useState(leaderList);
  const [teamMembers] = useState(previewTeamMembers);
  const [myTeams, setMyTeams] = useState(null);
  const [gameMessages] = useState(previewGameMessages);
  const [gameElements] = useState(gameElementsShortList);
  const [actionItems, setActionItems] = useState(null);
  const [gameStats] = useState(previewGameStats);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = IsDesktop();
  const isTablet = IsTablet();
  const isMobile = IsMobile();
  // Tablet and mobile share the compact head bar; desktop and largeTablet share the full one.
  const useMobileHeadBar = isTablet || isMobile;

  useEffect(() => {
    console.log(currentUser);
    if (!currentUser) return;
    if (currentUser.uid !== "preview-player") {
      navigate('/logout?redirectUrl=/preview');
    }
    
    const savedPlayerData = localStorage.getItem('previewPlayerData')
      ? JSON.parse(localStorage.getItem('previewPlayerData'))
      : null;
      console.log(savedPlayerData);
    if (savedPlayerData) {
      const player = Object.values(completePlayerData)
        .find(p => p.playerId === savedPlayerData.playerId);
      setPlayerData(player);
    }
  }, [currentUser])

  useEffect(() => {
    if (playerData) {
      const allActionItems = {}
      for (let ai of Object.values(previewPendingActionItems)) {
        if (ai.playerId === playerData.playerId) {
          allActionItems[ai.id] = ai;
        }
      }
      for (let ai of Object.values(previewCompleteActionItems)) {
        if (ai.playerId === playerData.playerId) {
          allActionItems[ai.id] = ai;
        }
      }
      setActionItems(allActionItems);
    }
    if (
      !playerData ||
      !previewPlayerCurrentUsers[playerData.path] ||
      !previewPlayerUserProfiles[playerData.path]
    ) {
      // dispatch(setCurrentUser({}));
      // dispatch(setMembership(null));
      // dispatch(setUserProfile({}));
      return;
    } 
    dispatch(setCurrentUser(previewPlayerCurrentUsers[playerData.path]));
    dispatch(setMembership(null));
    dispatch(setUserProfile(previewPlayerUserProfiles[playerData.path]));
  }, [playerData, previewPlayerCurrentUsers, previewPlayerUserProfiles, dispatch])

  useEffect(() => {
    if (!teamMembers || !playerData) return;
    let myTeamArr = [];
    for (let team of Object.values(teamMembers)) {
      if (team.members && team.members.includes(playerData.path)) {
        myTeamArr.push(team.path);
      }
    }
    setMyTeams([...myTeamArr]);
  }, [teamMembers, playerData])

  function updatePlayerData(newData) {
    setPlayerData(newData);
  }

  // Built once so every breakpoint renders the same content with the same props.
  const gameContent = (
    <PlayerGameContent
      gameData={gameData}
      playerData={playerData}
      updatePlayerData={updatePlayerData}
      gameElements={gameElements}
      actionItems={actionItems}
      gameStats={gameStats}
      playerList={playerList}
      teamMembers={teamMembers}
      myTeams={myTeams}
      gameMessages={gameMessages}
    />
  );

  return (
    <div>
      {
        (gameData && playerData)
          ?
          <div className='play-game-page' style={
            (gameData.bg.type === 'gradient')
              ?
              { 'background': `linear-gradient(to bottom, ${gameData.bg.hexTop}, ${gameData.bg.hexBottom})` }
              :
              { 'backgroundImage': `url("${gameData.bg.url}")` } // no-repeat center center fixed
          }>
            {
              (useMobileHeadBar)
                ?
                <PlayHeadBarMobile
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  teamMembers={teamMembers} />
                :
                <PlayHeadBar
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements} />
            }
            {
              (isDesktop)
                ?
                <div className='play-game-container'>
                  <div className='play-game-content'>
                    {gameContent}
                  </div>
                </div>
                :
                gameContent
            }
          </div>
          :
          <div className='loading-page'>
            <Loader />
          </div>
      }
      <PreviewBorder />
    </div>
  )
}

export default PreviewPlayerLanding